import { Injectable, Inject, Optional } from "@angular/core";
import { AppStoreClient, API_BASE_URL, OrderResult } from "./DixApiClient";
import { HttpClient, HttpHeaders, HttpResponseBase } from "@angular/common/http";
import { mergeMap as _observableMergeMap, catchError as _observableCatch } from "rxjs/operators";
import { Observable, throwError as _observableThrow, of as _observableOf } from "rxjs";

@Injectable({
    providedIn: "root"
})
export class AppStoreClientEx extends AppStoreClient {
    private _http: HttpClient;
    private _baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super(http, baseUrl);
        this._http = http;
        this._baseUrl = baseUrl ? baseUrl : "";
    }

    createOrUpdateOrderEx(
        sessionKey?: string | null | undefined,
        userId?: number | undefined,
        sku?: string | null | undefined,
        chekaoutId?: string | null | undefined,
        checkoutUrl?: string | null | undefined,
        checkoutData?: string | null | undefined,
        orderId?: number | null | undefined
    ): Observable<OrderResult> {
        let url_ = this._baseUrl + "/api/AppStore/CreateOrUpdateOrder";

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                Accept: "application/json"
            })
        };

        return this._http
            .post(
                url_,
                {
                    userId: userId,
                    chekaoutId: chekaoutId,
                    checkoutUrl: checkoutUrl,
                    checkoutData: checkoutData,
                    orderId: orderId,
                    sessionKey: sessionKey,
                    sku: sku
                },
                options_
            )
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processCreateOrUpdateOrder(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processCreateOrUpdateOrder(<any>response_);
                        } catch (e) {
                            return <Observable<OrderResult>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<OrderResult>>(<any>_observableThrow(response_));
                })
            );
    }
}
